<template>
  <div class="personal-m-cn">
    <van-form @submit="register" class="van-form" validate-first>
      <div class="flex">
        <label class="star">中文姓名</label>
        <van-field
          v-model="datas.chineseName"
          :rules="[{ required: true, message: '請輸入姓名' }]"
          class="field-input"
        />
      </div>
      <div class="flex">
        <label class="star">語言</label>
        <el-select
          @change="getLanguageSelected"
          class="select-language-personal"
          v-model="datas.selectLanguage"
          placeholder="請選擇"
        >
          <el-option
            v-for="item in language"
            :key="item.code"
            :value="item.code"
            :label="item.chT_DESC"
          >
          </el-option
        ></el-select>
      </div>
      <div class="flex">
        <label class="star">手提電話</label>
        <div>
          <div style="width: 201px" class="select-flex">
            <el-select
              @change="getPhoneNumberCode"
              class="select-phone"
              v-model="datas.selectPhoneNumber"
              placeholder="請選擇"
            >
              <el-option
                v-for="item in areaCode"
                :key="item.areaCode"
                :value="item.areaCode"
                :label="item.areaCode"
              >
              </el-option>
            </el-select>
            <van-field
              v-model="datas.phoneNumber"
              type="number"
              :rules="[
                {
                  pattern: phoneNumberPattern,
                  required: true,
                  message: phoneNumberMessage,
                },
              ]"
              class="field-phoneNumber"
            />
          </div>
        </div>
      </div>
      <div class="flex">
        <label>住宅電話</label>
        <div>
          <div style="width: 201px" class="select-flex">
            <el-select
              @change="getHouseNumber"
              class="select-phone"
              v-model="datas.selectHouseNumber"
              placeholder="請選擇"
            >
              <el-option
                v-for="(item, index) in areaCode"
                :key="index"
                :value="item.areaCode"
                :label="item.areaCode"
              >
              </el-option>
            </el-select>
            <van-field
              type="number"
              :rules="[
                {
                  validator: validateHouseNumber,
                  message: houseNumberMessage,
                },
              ]"
              v-model="datas.houseNumber"
              class="field-phoneNumber"
            />
          </div>
        </div>
      </div>
      <div class="flex">
        <label>電子郵箱</label>
        <van-field
          :rules="[
            {
              validator: validateEmail,
              message: '請輸入有效的電子郵件',
            },
          ]"
          v-model="datas.email"
          class="field-input"
        />
      </div>
      <div class="flex">
        <label class="star">區域</label>
        <el-select
          class="select-language-personal"
          v-model="datas.selectRegion"
          filterable
          placeholder="請選擇"
          no-match-text=""
          @change="getRegionSelected"
        >
          <el-option
            v-for="item in region"
            :key="item.region_Code"
            :label="item.chT_DESC"
            :value="item.region_Code"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex">
        <label class="star">地區</label>
        <el-select
          :disabled="datas.selectRegion === ''"
          class="select-language-personal"
          v-model="datas.selectDistrict"
          filterable
          placeholder=""
          no-match-text=""
          no-data-text=""
        >
          <el-option
            v-for="item in filterDistrict"
            :key="item.districtCode"
            :label="item.district_CName"
            :value="item.districtCode"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex">
        <label class="star" for="">送貨地址</label>
        <van-field
          class="field-input"
          type="textarea"
          v-model="datas.address1"
          :rules="[{ required: true, message: '請輸入送貨地址' }]"
          placeholder="地址1"
        ></van-field>
      </div>
      <div class="flex">
        <label></label>
        <van-field
          class="field-input"
          type="textarea"
          v-model="datas.address2"
          placeholder="地址2"
        ></van-field>
      </div>
      <div class="flex">
        <van-checkbox
          @change="clearContact"
          checked-color="#999"
          v-model="datas.checked"
          shape="square"
          >送貨聯絡人與客戶本人相同</van-checkbox
        >
      </div>
      <div class="flex">
        <label :class="datas.checked ? '' : 'star'">送貨聯絡人中文姓名</label>
        <van-field
          :disabled="datas.checked"
          v-model="datas.contact_Name"
          :rules="[
            {
              required: true,
              message: '請輸入姓名',
            },
          ]"
          class="field"
        />
      </div>
      <div class="flex">
        <!-- delivery:送货 -->
        <label :class="datas.checked ? '' : 'star'">送貨聯絡人語言</label>
        <el-select
          :disabled="datas.checked"
          class="select-language"
          v-model="datas.Address_Language"
          placeholder="請選擇"
        >
          <el-option
            v-for="item in language"
            :key="item.code"
            :value="item.code"
            :label="item.chT_DESC"
          ></el-option>
        </el-select>
      </div>
      <div class="flex">
        <label :class="datas.checked ? '' : 'star'">送貨聯絡人手提電話</label>
        <div>
          <div class="select-flex">
            <el-select
              :disabled="datas.checked"
              @change="getContactPhone"
              class="select-phone"
              v-model="datas.contact_Mobile_Coun_Code"
              placeholder="請選擇"
            >
              <el-option
                v-for="item in areaCode"
                :key="item.areaCode"
                :value="item.areaCode"
                :label="item.areaCode"
              ></el-option>
            </el-select>
            <van-field
              :disabled="datas.checked"
              v-model="datas.contact_Mobile"
              class="field-phoneNumber"
              :rules="[
                {
                  pattern: contactPhoneParrent,
                  required: true,
                  message: contactPhoneMessage,
                },
              ]"
            />
          </div>
        </div>
      </div>
      <!-- <div class="tips">
        我們所收集關於顧客的個人資料，只會轉移予第三方送貨公司用作訂單送貨用途。如有需要再進一步了解APITA/UNY的私隱政策及個人資料收集聲明，敬請瀏覽以下網址: 
        <br>
        <el-link style="font-size: 14px;" :underline="false" type="primary" target="_blank" href="https://apitauny.com.hk/privacy-notice/">https://apitauny.com.hk/privacy-notice/</el-link>
      </div> -->
      <div class="tips">
        我們所收集關於顧客的個人資料，只會轉移予第三方送貨公司用作訂單送貨用途。如有需要再進一步了解千色Citistore的私隱政策及個人資料收集聲明，敬請瀏覽以下網址: 
        <br>
        <el-link style="font-size: 14px;" :underline="false" type="primary" target="_blank" href="https://www.citistore.com.hk/privacy_policy_chi/">https://www.citistore.com.hk/privacy_policy_chi/</el-link>
      </div>
      <div class="btn">
        <van-button
          native-type="button"
          @click="clear()"
          type="default"
          style="width: 70px; height: 35px; background-color: #f1f1f1; font-size: 16px;letter-spacing:2px;"
          size="normal"
          >清除</van-button
        >
        <van-button
          native-type="submit"
          type="primary"
          style="width: 70px; height: 35px;text-align:center;font-size: 16px;letter-spacing:2px;"
          size="normal"
          >登記</van-button
        >
      </div>
    </van-form>
    <div v-if="isShow" id="imgver"></div>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";

import {
  getAreaCode,
  getDistrict,
  getLanguage,
  getRegion,
  customerRegister,
} from "@/api/index.js";

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      getAreaCode,
      getDistrict,
      getLanguage,
      getRegion,
      customerRegister,
      isShow: true,
      datas: {
        chineseName: "",
        selectLanguage: undefined,
        selectPhoneNumber: undefined,
        phoneNumber: "",
        selectHouseNumber: "",
        houseNumber: "",
        email: "",
        selectRegion: "",
        selectDistrict: "",
        checked: true,
        contact_Name: "",
        Address_Language: "",
        contact_Mobile_Coun_Code: undefined,
        contact_Mobile: "",

        address1: "",
        address2: "",
        areaCode: undefined,
      },
      phoneNumberPattern: /^\d{8}$/,
      houseNumberPattern: /^\d{8}$/,
      contactPhoneParrent: /^\d{8}$/,
      phoneNumberMessage: "請輸入8位電話號碼",
      houseNumberMessage: "請輸入8位電話號碼",
      contactPhoneMessage: "請輸入8位電話號碼",
      areaCode: [],
      language: [],
      region: [],
      // 筛选完的District数据
      filterDistrict: [],
      // 初始未筛选的District数据
      district: [],
    };
  },
  methods: {
    /**
     * 登记方法
     */
    register() {
      this.$imgVer({
        el: '$("#imgver")',
        width: "260",
        height: "116",
        img: [
          require("@/assets/images/imgver/ver-1.png"),
          require("@/assets/images/imgver/ver-2.png"),
          require("@/assets/images/imgver/ver-3.png"),
          require("@/assets/images/imgver/ver-4.png"),
          require("@/assets/images/imgver/ver-5.png"),
          require("@/assets/images/imgver/ver-6.png"),
        ],
        lan: "cn", //'cn' or 'en'
        success: () => {
          this.goRegister();
          setTimeout(() => {
            this.isShow = false;
          }, 500);
          setTimeout(() => {
            this.isShow = true;
          }, 1000);
        },
        error: function () {
          return false;
        },
      });
    },

    goRegister() {
      let query = {
        appkey: "HD123456",
        secretkey: "HD123456",
        create_Platform: "MOBILE",
        customer_title: "",
        customer_Name: this.datas.chineseName,
        customer_Ename: "",
        company_Name: "",
        language: this.datas.selectLanguage,
        home_Tel: this.datas.houseNumber,
        mobile: this.datas.phoneNumber,
        email: this.datas.email,
        home_Coun_Code: this.datas.selectHouseNumber,
        mobile_Coun_Code: this.datas.selectPhoneNumber,
        contact_Name: this.datas.contact_Name,
        contact_Ename: "",
        address1: this.datas.address1,
        address2: this.datas.address2,
        E_ADDRESS1: "",
        E_ADDRESS2: "",
        region_Code: this.datas.selectRegion,
        district_Code: this.datas.selectDistrict,
        contact_Mobile: this.datas.contact_Mobile,
        contact_Mobile_Coun_Code: this.datas.contact_Mobile_Coun_Code,
        Is_Same: this.datas.checked ? 1 : 0,
        Title: "",
        Address_Language: this.datas.Address_Language,
        CREATE_PLATFORM: "MOBILE",
      };
      this.customerRegister(query).then((res) => {
        // 返回状态码验证
        if (res.status === 200 && res.data.resultCode === "Success") {
          Dialog.alert({
            message: "登 記 成 功",
            confirmButtonText: "确定",
            confirmButtonColor: "#07c160",
          }).then(() => {});
          this.datas.chineseName = "";
          this.datas.selectEnglishNameTitle = "";
          this.datas.phoneNumber = "";
          this.datas.houseNumber = "";
          this.datas.email = "";
          this.datas.selectRegion = "";
          this.datas.selectDistrict = "";
          this.datas.contact_Name = "";
          this.datas.contact_Mobile = "";
          this.datas.contact_Mobile_Coun_Code = undefined;
          this.datas.address1 = "";
          this.datas.address2 = "";
        } else {
          setTimeout(() => {
            Toast("登記超時，請重試！");
          }, 5000);
        }
      });
    },

    //清除
    clear() {
      Dialog.confirm({
        message: "確認清除所有資料？",
        confirmButtonText: "是",
        cancelButtonText: "否",
        confirmButtonColor: "#07c160",
        className: "van-dialog__message",
      })
        .then(() => {
          // on confirm
          this.datas.chineseName = "";
          this.datas.phoneNumber = "";
          this.datas.houseNumber = "";
          this.datas.email = "";
          this.datas.selectRegion = "";
          this.datas.selectDistrict = "";
          this.datas.contact_Name = "";
          this.datas.Address_Language = undefined;
          this.datas.contact_Mobile_Coun_Code = undefined;
          this.datas.contact_Mobile = "";
          this.datas.address1 = "";
          this.datas.address2 = "";
          setTimeout(() => {
            Toast("清除成功!");
          }, 1000);
        })
        .catch(() => {
          // on cancel
        });
    },
    getLanguageSelected() {},
    /**
     * 监听选中的areaCode
     */
    getPhoneNumberCode() {
      if (this.datas.checked) {
        if (this.datas.selectPhoneNumber === "+852") {
          this.phoneNumberPattern = /^\d{8}$/;
          this.phoneNumberMessage = "請輸入8位電話號碼";

          this.contactPhoneParrent = /^\d{8}$/;
          this.contactPhoneMessage = "請輸入8位電話號碼";
        } else if (this.datas.selectPhoneNumber === "+853") {
          this.phoneNumberPattern = /^\d{8}$/;
          this.phoneNumberMessage = "請輸入8位電話號碼";

          this.contactPhoneParrent = /^\d{8}$/;
          this.contactPhoneMessage = "請輸入8位電話號碼";
        } else if (this.datas.selectPhoneNumber === "+86") {
          this.phoneNumberPattern = /^\d{11}$/;
          this.phoneNumberMessage = "請輸入11位電話號碼";
          this.contactPhoneParrent = /^\d{11}$/;
          this.contactPhoneMessage = "請輸入11位電話號碼";
        }
      }
      if (!this.datas.checked) {
        if (this.datas.selectPhoneNumber === "+852") {
          this.phoneNumberPattern = /^\d{8}$/;
          this.phoneNumberMessage = "請輸入8位電話號碼";
        } else if (this.datas.selectPhoneNumber === "+853") {
          this.phoneNumberPattern = /^\d{8}$/;
          this.phoneNumberMessage = "請輸入8位電話號碼";
        } else if (this.datas.selectPhoneNumber === "+86") {
          this.phoneNumberPattern = /^\d{11}$/;
          this.phoneNumberMessage = "請輸入11位電話號碼";
        }
      }
    },
    /**
     * 家庭电话正则
     */
    getHouseNumber() {
      if (this.datas.selectHouseNumber === "+852") {
        this.houseNumberPattern = /^\d{8}$/;
        this.houseNumberMessage = "請輸入8位電話號碼";
        console.log(this.houseNumberPattern);
      } else if (this.datas.selectHouseNumber === "+853") {
        this.houseNumberPattern = /^\d{8}$/;
        this.houseNumberMessage = "請輸入8位電話號碼";
      } else if (this.datas.selectHouseNumber === "+86") {
        this.houseNumberPattern = /^\d{11}$/;
        this.houseNumberMessage = "請輸入11位電話號碼";
      }
    },

    getContactPhone() {
      if (!this.datas.checked) {
        if (this.datas.contact_Mobile_Coun_Code === "+852") {
          this.contactPhoneParrent = /^\d{8}$/;
          this.contactPhoneMessage = "請輸入8位電話號碼";
        } else if (this.datas.contact_Mobile_Coun_Code === "+853") {
          this.contactPhoneParrent = /^\d{8}$/;
          this.contactPhoneMessage = "請輸入8位電話號碼";
        } else if (this.datas.contact_Mobile_Coun_Code === "+86") {
          this.contactPhoneParrent = /^\d{11}$/;
          this.contactPhoneMessage = "請輸入11位電話號碼";
        }
      }
    },
    /**
     *根据Region过滤district
     */
    getRegionSelected() {
      this.datas.selectDistrict = "";
      this.filterDistrict = [];
      this.district.filter((item) => {
        if (this.datas.selectRegion === item.regionCode.slice(0, 2)) {
          this.filterDistrict.push(item);
          return;
        } else if (this.datas.selectRegion === item.regionCode) {
          this.filterDistrict.push(item);
          return;
        }
      });
    },
    getDistrictSelected() {},
    /**
     * checked為false 清空contact資料
     */
    clearContact() {
      if (!this.datas.checked) {
        this.datas.contact_Name = "";
        this.datas.contact_Mobile = "";
        this.areaCode.forEach((item) => {
          if (item.isdefault === 1) {
            this.datas.contact_Mobile_Coun_Code = item.areaCode;
          }
          this.language.forEach((item) => {
            if (item.isdefault === 1) {
              this.datas.Address_Language = item.code;
            }
          });
        });
      }
    },
    validateHouseNumber(value, rule) {
      if (value) {
        // return true;
        if (this.datas.selectHouseNumber === "+852") {
          return /^\d{8}$/.test(value);
        } else if (this.datas.selectHouseNumber === "+853") {
          return /^\d{8}$/.test(value);
        } else if (this.datas.selectHouseNumber === "+86") {
          return /^\d{11}$/.test(value);
        }
      }
      return true;
    },
    validateEmail(value, rule) {
      if (value) {
        return /(?=^.{3,256}$)^([\w\-]+([\.][\w\-]+)*)@[a-zA-Z0-9][a-zA-Z0-9\-\.]*[\.][A-Za-z]{2,6}$/.test(value)
      }
      return true;
    },
  },
  created() {
    let query = {
      appkey: "HD123456",
      secretkey: "HD123456",
    };
    /**
     * 获取AreaCode
     */
    this.getAreaCode(query).then((result) => {
      this.areaCode = result.data.areaCode;
      this.areaCode.forEach((item) => {
        if (item.isdefault === 1) {
          this.datas.selectPhoneNumber = item.areaCode;
          this.datas.selectHouseNumber = item.areaCode;
          this.datas.contact_Mobile_Coun_Code = item.areaCode;
        }
      });
    });
    /**
     * 获取District
     */
    this.getDistrict(query).then((result) => {
      this.district = result.data.district;
    });
    /**
     * 获取Language
     */
    this.getLanguage(query).then((result) => {
      this.language = result.data.language;
      this.language.forEach((item) => {
        if (item.isdefault === 1) {
          this.$nextTick(() => {
            this.datas.selectLanguage = item.code;
            this.datas.Address_Language = item.code;
          });
          return;
        }
      });
    });
    /**
     * 获取Region
     */
    this.getRegion(query).then((result) => {
      this.region = result.data.region;
    });
  },

  mounted() {
    if (
      !!this.datas.selectLanguage ||
      !!this.datas.selectPhoneNumber ||
      !!this.datas.selectHouseNumber ||
      !!this.datas.selectRegion ||
      !!this.datas.selectDistrict
    ) {
      window.location.reload();
    }
  },

  updated() {
    /**
     * contact 与 customer
     */
    if (this.datas.checked) {
      this.datas.contact_Name = this.datas.chineseName;
      this.datas.Address_Language = this.datas.selectLanguage;
      this.datas.contact_Mobile_Coun_Code = this.datas.selectPhoneNumber;
      this.datas.contact_Mobile = this.datas.phoneNumber;
    }
  },
};
</script>

<style lang="scss">
.van-dialog__message {
  font-size: 15px !important;
  padding: 0 !important;
}
.van-field__control {
  font-size: 16px;
}
.el-select-dropdown__item {
  font-size: 16px !important;
}
.personal-m-cn {
  width: 95%;
  height: 100vh;
  font-size: 16px;
  padding: 0 auto;
  .van-form {
    padding: 10px 0 0 3%;
    .flex {
      display: flex;
      flex-direction: row;
      line-height: 30px;
      justify-content: space-between;
      // align-items: center;
      background-color: #fff;
      border-bottom: 1px solid #e5e5e5;
      padding: 6px;
      .star::after {
        content: "*";
        color: #f00;
        margin-left: 6px;
      }
      .field-input {
        width: 188px;
        font-size: 15px;
        padding: 0;
      }
      .field {
        width: 162px;
        font-size: 15px;
        padding: 0;
      }
      .select-language-personal {
        width: 201px;
        border: 0;
        padding: 3px 0;
      }
      .select-language {
        width: 174px;
        border: 0;
        padding: 3px 0;
      }
      .select-language:active {
        border: 0;
      }
      .select-flex {
        width: 174px;
        display: flex;
        align-self: flex-start;
        align-items: center;
        .select-phone {
          border: 0;
        }
        .field-phoneNumber {
          padding: 0 0 0 8px;
        }
      }
    }
  }
  .btn {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
   
    margin-top: 30px;
    padding-bottom: 20px;
  }
  .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border: none;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: 17px;
    height: 18px;
    line-height: 18px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .el-input {
    position: relative;
    font-size: 0.8em;
    display: inline-block;
    width: 100%;
  }
  .el-input__icon {
    height: 100%;
    width: 25px;
    text-align: center;
    transition: all 0.3s;
    line-height: 18px;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border-color: #e4e7ed;
    color: #c0c4cc;
    cursor: not-allowed;
  }
}
</style>
